import styles from './UserInfo.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import { RootState } from 'redux/store';
import { Button } from 'ui/Button';
import doc from './img/iconDocFolder.svg';
import { ModalProfile } from 'components/ModalProfile';
import { ReactComponent as IconPlus } from './img/iconPlus.svg';
import { ReactComponent as IconChevronDown } from './img/iconChewronDown.svg';
import { ReactComponent as IconChevronUp } from './img/iconChewronUp.svg';
import { ReactComponent as IconWallet } from './img/IconWaller.svg';
import { useState, type FC } from 'react';
import { Popover } from '@mantine/core';
import { Avatar } from 'components/Avatar';
import { resetOrderInfo } from 'redux/ordersDetails/slice';
import { useCanManage } from 'hooks/useCanManage';
import { useGetProfileQuery } from 'redux/Api/profileApi/ProfileApi';
import { UserInfoResponse } from 'redux/Api/profileApi/type';

interface UserInfoTypes {
  close?: () => void;
  userData?: UserInfoResponse;
}

export const UserInfo: FC<UserInfoTypes> = ({ close, userData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const canManage = useCanManage();

  const { data, isLoading } = useGetProfileQuery();

  const [opened, setOpened] = useState(false);

  const [showModalProfile, setShowModalProfile] = useState(false);

  const { balance, name, hold, avatar, to_be_paid } = useSelector(
    (state: RootState) => state.authSlice,
  );

  if (isLoading) return null;

  const isSigned = data?.beneficiary?.document?.is_signed;

  const getUserRoleForCompany = () => {
    if (!userData?.roles || !data?.id) return 'Администратор';

    const companyId = data.id;
    const employeeRole = `employee-${companyId}`;

    const hasEmployeeRole = userData.roles.some((role: string) => role === employeeRole);

    return hasEmployeeRole ? 'Сотрудник' : 'Администратор';
  };

  return (
    <div className={styles.root}>
      {isSigned ? (
        <div className={styles.root_info}>
          <div className={styles.root_info_wrapper}>
            <div className={styles.root_info_wrapper_mobile}>
              <div className={styles.root_info__balance_block}>
                <p className={styles.root_info__balanceTitle}>Баланс</p>
                <p className={styles.root_info__balance}>
                  {balance ? addSpaceNumber(balance) : 0}
                </p>
              </div>
              <div className={styles.root_info__column}>
                <p className={styles.root_info__subtitle}>Зарезервировано</p>
                <p className={styles.root_info__hold}>
                  {hold ? addSpaceNumber(hold) : 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.root_info}>
          <p className={styles.root_info__alt}>Для начала работы - прими оферту</p>
          <Button
            icon
            src={doc}
            className={styles.btnAlt}
            onClick={() => {
              navigate('/profile');
              close?.();
            }}
            theme='filed'>
            Подписать оферту
          </Button>
        </div>
      )}
      {canManage && (
        <div className={styles.actions}>
          <Button
            className={styles.btn}
            size='L'
            theme='filed'
            onClick={() => {
              dispatch(resetOrderInfo());
              navigate('/orders/create');
              close?.();
            }}>
            <div className={styles.btn_wrapper}>
              <IconPlus />
              <span>Создать заказ</span>
            </div>
          </Button>
          <Popover
            withinPortal={false}
            position='top-end'
            width={'calc(100% - 32px)'}
            radius={'4px'}
            opened={opened}
            offset={6}
            onChange={setOpened}
            zIndex={10000}>
            <Popover.Target>
              <div
                className={opened ? styles.toggle_active : styles.toggle}
                onClick={() => setOpened((o) => !o)}>
                {opened ? <IconChevronUp /> : <IconChevronDown />}
              </div>
            </Popover.Target>
            <Popover.Dropdown
              p='0'
              style={{
                boxShadow: '0px 0px 10px 0px rgba(0, 32, 51, 0.10)',
                border: 'none',
              }}>
              <div
                className={styles.balanceBtn}
                onClick={() => {
                  setShowModalProfile(true);
                  setOpened(false);
                }}>
                <IconWallet />
                <span>Пополнить баланс</span>
              </div>
            </Popover.Dropdown>
          </Popover>
        </div>
      )}

      <div className={styles.divider} />
      <div className={styles.root_profile}>
        <Link to='/profile'>
          <div style={{ display: 'flex' }}>
            <div className={styles.root_avatar}>
              {avatar ? (
                <img className={styles.avatar} src={avatar} alt={name} />
              ) : (
                <Avatar
                  avatar={avatar}
                  statusActive=''
                  id={1}
                  name={name}
                  height={'40px'}
                  width={'40px'}
                />
              )}
            </div>
            <div className={styles.root_profile__name}>
              <p>{name}</p>
              <span>{getUserRoleForCompany()}</span>
            </div>
          </div>
        </Link>
      </div>
      {showModalProfile && (
        <ModalProfile
          showModalProfile={showModalProfile}
          title='ООО "Рога и Копыта"'
          ls='123456789'
          setShowModalProfile={setShowModalProfile}
          avatar=''
          sum='123'
        />
      )}
    </div>
  );
};
